import Input from "components/common/inputs";
import { TYPO } from "styles/Typo";
import { formatAmountManKo } from "./result/format";
import Button from "components/common/buttons/buttons";

export function SurveyTitle({ text }: { text: string }) {
  if (!text || typeof text !== "string") return null;
  return (
    <p
      className={`pt-4 px-6 w-full text-[26px] leading-[140%] font-[600]  text-gray90 whitespace-pre-line`}
    >
      {text?.replace(/\\n/g, "\n") ?? ""}
    </p>
  );
}

// amout input
export function AmountInput({
  value,
  setValue,
  dataGtmId,
}: {
  value: number | null;
  setValue: (value: number) => void;
  dataGtmId?: string;
}) {
  return (
    <div className="flex flex-col items-end  gap-1 w-full h-[78px]">
      <div className="w-full">
        <Input
          type="line"
          placeholder="금액을 입력해주세요"
          value={value ? value.toString() : ""}
          setValue={(value) => setValue(Number(value))}
          size={"lg"}
          width="w-full"
          inputMode="numeric"
          dataTestId="saa-common-amount-input"
          dataGtmId={dataGtmId}
        />
      </div>

      <p className={`${TYPO.TYPO7_1_RG} text-gray60`}>
        {value ? formatAmountManKo(value) : ""}
      </p>
    </div>
  );
}

// amout input helper
export function AmountInputHelper({
  setValue,
  units,
  value,
  dataGtmId,
}: {
  setValue: (value: number) => void;
  units: number[];
  value: number;
  dataGtmId?: string;
}) {
  return (
    <div className="flex items-center gap-1">
      {units.map((unit, index) => (
        <Button
          type="tertiary"
          size="sm"
          text={`+${formatAmountManKo(unit).replace(/원/g, "")}`}
          clickHandler={() => setValue(value + unit)}
          btnClass="whitespace-nowrap grow flex-1"
          key={index}
          dataGtmId={dataGtmId}
        />
        // <div
        //   key={unit}
        //   className="px-1 py-[10px] flex items-center gap-2 w-full cursor-pointer"
        //   onClick={() => setValue(unit)}
        // >
        //   <p className={`${TYPO.TYPO5_1_MD} text-gray80`}>
        //     +{unit?.toLocaleString()}
        //   </p>
        // </div>
      ))}
    </div>
  );
}
